// SIWS CUSTOM (2026-10-08): Gift Bag product page — gift-bag-picker.js
// Fixed packs: one button per variant, no quantity stepper. Each Add to Cart
// adds ONE pack. When the section has data-imprint="true", Dealer Name and
// Phone Number are required and sent as line item properties (same keys as
// the Dealer Gift Card). Phone formatted (586) 322-6110. Publishes cartUpdate.

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('siws-gb-form');
    if (!form) return;

    var needsImprint = form.dataset.imprint === 'true';
    var packs    = form.querySelectorAll('[data-gb-pack]');
    var nameEl   = document.getElementById('siws-gb-dealer-name');
    var phoneEl  = document.getElementById('siws-gb-phone');
    var errorEl  = document.getElementById('siws-gb-error');
    var atcBtn   = document.getElementById('siws-gb-atc-btn');
    var selected = null;

    // Phone: 10 digits -> "(586) 322-6110". Anything else is left as typed.
    function formatPhone(raw) {
      var digits = String(raw || '').replace(/\D/g, '');
      if (digits.length !== 10) return String(raw || '').trim();
      return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
    }

    function imprintValid() {
      if (!needsImprint) return true;
      return !!(nameEl && nameEl.value.trim() && phoneEl && phoneEl.value.trim());
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.setAttribute('data-visible', 'true');
    }
    function clearError() {
      errorEl.textContent = '';
      errorEl.removeAttribute('data-visible');
    }

    function updateAtc() {
      if (!selected) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Choose a pack size to continue';
      } else if (!imprintValid()) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Enter dealer name and phone to continue';
      } else {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add ' + selected.dataset.title + ' to Cart — ' + selected.dataset.priceLabel;
      }
    }

    packs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        packs.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        selected = btn;
        clearError();
        updateAtc();
      });
    });

    if (needsImprint) {
      [nameEl, phoneEl].forEach(function (el) {
        if (el) el.addEventListener('input', updateAtc);
      });
      if (phoneEl) {
        phoneEl.addEventListener('blur', function () {
          phoneEl.value = formatPhone(phoneEl.value);
          updateAtc();
        });
      }
    }

    atcBtn.addEventListener('click', function () {
      if (atcBtn.disabled || !selected || !imprintValid()) return;

      var item = { id: parseInt(selected.dataset.variantId, 10), quantity: 1 };
      if (needsImprint) {
        phoneEl.value = formatPhone(phoneEl.value);
        item.properties = {
          'Dealer Name':  nameEl.value.trim(),
          'Phone Number': phoneEl.value.trim(),
        };
      }

      var originalText   = atcBtn.textContent;
      atcBtn.disabled    = true;
      atcBtn.textContent = 'Adding…';
      clearError();

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = {
        items:        [item],
        sections:     cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'],
        sections_url: window.location.pathname,
      };

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(body),
      })
        .then(async function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          var responseData = await res.json();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'siws-gift-bag', cartData: responseData });
          }
          if (cart) {
            cart.renderContents(responseData);
          } else {
            var newBubbleHTML = responseData.sections && responseData.sections['cart-icon-bubble'];
            var liveBubble = document.getElementById('cart-icon-bubble');
            if (newBubbleHTML && liveBubble) {
              var parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
              var inner = parsed.querySelector('.shopify-section');
              if (inner) liveBubble.innerHTML = inner.innerHTML;
            }
          }
          atcBtn.disabled    = false;
          atcBtn.textContent = originalText;
        })
        .catch(function () {
          atcBtn.disabled    = false;
          atcBtn.textContent = originalText;
          showError('Something went wrong — please try again.');
        });
    });

    updateAtc();
  });
})();
